import { jsx as _jsx } from "react/jsx-runtime";
import { AutocompleteInput, ReferenceInput } from "react-admin";
var SelectArea = function (_a) {
    var tenantId = _a.tenantId, electionEventId = _a.electionEventId, source = _a.source, label = _a.label, onSelectArea = _a.onSelectArea, customStyle = _a.customStyle, isRequired = _a.isRequired, disabled = _a.disabled;
    var areaFilterToQuery = function (searchText) {
        if (!searchText || searchText.length == 0) {
            return { name: "" };
        }
        return { name: searchText.trim() };
    };
    return (_jsx(ReferenceInput, { fullWidth: true, reference: "sequent_backend_area", source: source, isRequired: isRequired, filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
        }, perPage: 100, enableGetChoices: function (_a) {
            var q = _a.q;
            return q && q.length >= 3;
        }, label: label, children: _jsx(AutocompleteInput, { TextFieldProps: { required: isRequired }, label: label, fullWidth: true, optionText: function (area) { return area.name; }, filterToQuery: areaFilterToQuery, onChange: onSelectArea, debounce: 100, sx: customStyle, isRequired: isRequired, disabled: disabled }) }));
};
export default SelectArea;
